var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapZoom"},[_c('div',{staticClass:"btn zoomIn",on:{"click":function($event){return _vm.changeLevel(1)}}},[_vm._v("+")]),_c('div',{staticClass:"btn zoomOut",on:{"click":function($event){return _vm.changeLevel(0)}}},[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }